import {Action, createReducer, on} from '@ngrx/store';
import * as LoginActions from '../actions/login.actions';

export const loginFeatureKey = 'login';

export interface State {
  loading: boolean;
  success: boolean;
  error: { code: number, message: string };
  isLogin: boolean;
  userData: any;
  forget: {
    loading: boolean,
    emailSent: boolean,
    error: string
  };
}

export const initialState: State = {
  loading: false,
  success: false,
  error: null,
  isLogin: false,
  userData: null,
  forget: {
    loading: false,
    emailSent: false,
    error: null
  }
};


export const reducer = createReducer(
  initialState,
  on(LoginActions.LogoutUserSuccess, (state) => ({...state, ...initialState})),
  on(LoginActions.forgetPassword, (state) => ({...state, forget: {...state.forget, loading: true, error: null}})),
  on(LoginActions.forgetPasswordSuccess, (state) => ({...state, forget: {...state.forget, loading: false, emailSent: true}})),
  on(LoginActions.forgetPasswordFailed, (state, action) => ({
    ...state,
    forget: {...state.forget, loading: false, emailSent: false, error: action.error}
  })),
  on(LoginActions.loginUser, (state) => ({...state, loading: true, error: null})),
  on(LoginActions.loginUserSuccess, (state, action) => ({...state, loading: false, isLogin: true, userData: action.userData})),
  on(LoginActions.loginUserFailed, (state, action) => ({...state, loading: false, error: {code: action.code, message: action.error}})),
  on(LoginActions.loadLogins, state => state)
);

